<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.SearchTheWarehouseRecords')"
      width="1000px"
      append-to-body
      :close-on-click-modal="false"
      class="app-main-inner edi-bill-search-selector"
    >

      <div class="app-main-inner-row">
        <el-form label-width="60px" label-position="left">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('SeaExport.WarehouseNo')">
                <el-input v-model="searchConditions.warehouseNo2" style="width:260px" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('SeaExport.ReceiptNo')">
                <el-input v-model="searchConditions.receiptNo" style="width:260px" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('SeaExport.warehouseOp')">
                <cargo-user-select
                  :default-value="searchConditions.warehouseOp||''"
                  style="width:260px;"
                  @change="item=>searchConditions.warehouseOp=item.value"
                />&nbsp;
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('SeaExport.deliveryCMP')">
                <cargo-company-select
                  :method-params="{customer:true,seaExport:true}"
                  :default-value="searchConditions.deliveryCmp||''"
                  style="width:260px;"
                  @change="item=>searchConditions.deliveryCmp=item.value"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('SeaExport.inDate')">
                <div style="display: flex;justify-content: space-between; width: 260px;">
                  <el-date-picker
                    v-model="searchConditions.inDateStart"
                    type="date"
                    style="width:125px;"
                    value-format="yyyy-MM-dd"
                  />
                  <span style="font-size: 12px;margin-left: 1px;margin-right: 1px;">-</span>
                  <el-date-picker
                    v-model="searchConditions.inDateEnd"
                    type="date"
                    style="width:125px;"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                  />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('SeaExport.Display')">
                <el-input-number v-model="searchConditions.maxResult" :min="10" :max="99999" controls-position="right" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item>
                <el-button type="primary" style="margin-left: -60px;" @click="queryHandler">{{ $t('SeaExport.Query') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0;">
        <cargo-ag-grid
          config-module="190005"
          :locale-text-func="_i18nGridLocalText"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="rowData"
          :enable-col-resize="true"
          :row-double-clicked="selectHandler"
          class="ag-theme-balham"
          style="width:100%;height:350px"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div slot="footer">
        <!--        <el-button type="primary" :disabled="!btnConfirm" @click="selectHandler">{{ $t('SeaExport.Confirm') }}</el-button>-->
        <el-button type="primary" @click="selectHandler">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { complexQuery } from '@/api/seaExport/warehouseIn'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'WarehousSearchDialog',
  components: { cargoAdvanceSelect, cargoUserSelect, cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        onRowClicked: event => {
          // this.selectedData = event.data
          // this.btnConfirm = true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.WareHouseName'),
          field: 'warehouse',
          width: 150
        }, {
          headerName: this.$t('SeaExport.inDate'),
          field: 'warehouseInDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.DamagedAndDamp'),
          field: 'broken',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantitySum',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weightSum',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3, true)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubageSum',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 3, true)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      selectedData: {},
      // btnConfirm: false,
      searchConditions: {
        lob: '',
        empty: false,
        warehouseNo: '',
        warehouseNo2: '',
        receiptNo: '',
        warehouseOp: '',
        deliveryCmp: '',
        inDateStart: '',
        inDateEnd: '',
        branchId: '',
        maxResult: '30'
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
        // this.btnConfirm = false
        this.selectedData = {}
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      // this.btnConfirm = false
      // 默认不查询 this.queryHandler()
    }
  },
  methods: {
    async queryHandler() {
      this.searchConditions.empty = true
      this.searchConditions.branchId = this.$store.getters.currentOfficeId
      this.searchConditions.lob = this.lob
      await cache.load(cacheName.USER, cacheName.CONFIG)
      // 前置仓不需要这个逻辑
      const stayWarehousingNew = parseInt(cache.config.get('StayWarehousingNew')) === 1
      if (!stayWarehousingNew) {
        let warehouseNo = this.searchConditions.warehouseNo2
        warehouseNo = warehouseNo.replace(/-/g, '')
        warehouseNo = warehouseNo.replace(/\s/g, ' ')
        this.searchConditions.warehouseNo = warehouseNo
      } else {
        this.searchConditions.warehouseNo = this.searchConditions.warehouseNo2
      }
      complexQuery(this.searchConditions).then(res => {
        this.rowData = [...res.data]
        if (this.gridApi) {
          this.gridApi.clearFocusedCell()
        }
      })
    },
    selectHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length > 0) {
        this.$emit('selectWarehouseHandler', selectedRows)
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
      }
    },
    // 设置不可选日期范围
    disabledDate(currDate) {
      if (currDate && this.searchConditions.inDateStart) {
        const start = ColumnUtils.dateLabelFunc(currDate)
        const end = ColumnUtils.dateLabelFunc(this.searchConditions.inDateStart)
        return start < end
      }
    },
    setSelectValue(obj) {
      this.searchConditions[obj.key] = obj.value
    }
  }
}
</script>

<style lang="scss">
  .edi-bill-search-selector {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
  }
</style>
